package org.example.abigail

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    org.example.abigail.inicializarFirebase()

    ComposeViewport(document.body!!) {
        App()

    }
}